// que necesitas limpiar section
function quenecesitasSection() {
  const all_items = document.querySelectorAll('.queNecesitasLimpiar .itemsWrapper .itemsWrapper__item a');
  const all_images = document.querySelectorAll('.queNecesitasLimpiar .itemsWrapper_image img');
  const itemsWrapper = document.querySelector('.itemsWrapper');
  
  if(all_items.length > 0){
    all_items.forEach(item =>{
      item.addEventListener("mouseover", (e)=>{
        let data_block = item.dataset.block;
        let match = false;
        all_images.forEach(img => {
          let img_block = img.dataset.block;
          if(img_block === data_block){
            img.classList.remove('hidden');
            match = true;
          }else{
            img.classList.add('hidden');
          }
        });

        if (!match) {
          const defaultImage = Array.from(all_images).find(img => img.dataset.block === 'default');
          if (defaultImage) {
            defaultImage.classList.remove('hidden');
          }
        }
      });
      
      // Efecto que al salir del contenedor: Se muestre la imagen por defecto del vehiculo
      
      itemsWrapper.addEventListener("mouseleave", function() {
        const defaultImage = Array.from(all_images).find(img => img.dataset.block === 'default');
        all_images.forEach(img => {
          img.classList.add('hidden');
        });
        defaultImage.classList.remove('hidden');
      });
    });
  }
}
quenecesitasSection();

// featured collection
function init_tabs_section() {
  const all_tabs = document.querySelectorAll('.featuredCollection .featured_tab__item');
  const all_content = document.querySelectorAll('.featuredCollection .js-content');
  if(all_tabs.length > 0){
    all_tabs.forEach(item =>{
      item.addEventListener("click", (e)=>{
        let data_block = item.dataset.content;
        all_tabs.forEach(tab => tab.classList.remove('active'));
        item.classList.add('active');
        all_content.forEach(content => {
          let content_block = content.id;
          if(content_block === data_block){
            content.classList.remove('productGridWrapper__content--hide');
          }else{
            content.classList.add('productGridWrapper__content--hide');
          }
        });
      });
    });
  }
}
init_tabs_section();

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      let counters = document.querySelectorAll('.counter');
      counters.forEach(counter =>{
        counter.innerText = '0';
          const updateCounter = () =>{
              const target = +counter.getAttribute('data-target')
              const c = +counter.innerText;
      
              const increment = target/100;
      
              if(c< target){
                  counter.innerText = `${Math.ceil(c+increment)}`
                  setTimeout(updateCounter,1)
              }else{
                  counter.innerText = target
              }
          }
          updateCounter();
      });
    } else {
      console.log('El elemento no es visible.');
    }
  });
});

// Seleccionamos el elemento que queremos observar
/*const observedElement = document.querySelector('.subcriptions');
observer.observe(observedElement);*/

/*---------------------------------------------------------------------------------------------------*/

/*var elem = document.querySelector('.ru-related-products');
var flkty = new Flickity( elem, {
  cellAlign: 'left',
  contain: true
});*/

/* Hide posts from blog posts */
let posts = document.querySelectorAll('.blog-articles__article');
let cargarMasBtn = document.querySelector('.cargar-mas__btn');

posts.forEach((item, index) => {
  if (index > 3) {
    item.classList.add('hidden');
  }
});
if(cargarMasBtn){
  cargarMasBtn.addEventListener("click", function(){
    posts.forEach((item, index) => {
      if (item.classList.contains('hidden')) {
        item.classList.toggle('hidden');
      }
    });
  });
}

//add to cart ajax
function add_to_cart_ajax(btn) {
  const input = document.querySelector(`#${btn.dataset.container} input`);
  if(input){
    const data = new URLSearchParams();
    data.append("id", input.value);
    data.append("quantity", 1);
    btn.setAttribute("disabled", "");
    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then(response => response.json())
    .then(() => {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      btn.removeAttribute("disabled");
    })
    .catch(error => console.error('Error:', error)); 
  }
}